// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-form-item-label {
  white-space: normal;
}
.ant-form-item-label label {
  display: inline-block;
  line-height: 1.3;
  margin-right: 12px;
}
.ant-form-item-label label:after {
  content: none !important;
}
.ant-btn {
  font-weight: 600;
}
.ant-btn {
  color: #00739D;
  box-shadow: #0086b6 0px 0px 0px 2px inset, rgba(40, 51, 63, 0.16) 0px 2px 4px 0px;
  border: none;
}
.ant-btn.ant-btn-link {
  box-shadow: none;
  color: #00739D;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
}
.ant-btn.ant-btn-link:hover {
  background-color: #F2F2F2;
}
.ant-btn.ant-btn-link:active {
  background-color: #E6E6E6;
  font-weight: 600;
}
.ant-btn:focus-visible {
  border: 2px orange solid;
}
.ant-btn.ant-btn-primary {
  box-shadow: rgba(40, 51, 63, 0.16) 0px 2px 4px 0px;
  color: #ffffff;
}
.ant-btn.ant-btn-primary:disabled {
  background-color: rgba(0, 115, 157, 0.5);
  color: #ffffff;
  cursor: auto;
}
.ant-btn.ant-btn-primary:disabled:hover {
  background-color: rgba(0, 115, 157, 0.5);
  color: #ffffff;
}
.ant-btn.ant-btn-primary:hover {
  background-color: #006083;
}
.ant-btn.ant-btn-primary:active {
  background-color: #00465F;
}
.ant-collapse-header {
  background-color: #ffffff;
}
.ant-radio-group {
  width: 100%;
  word-wrap: break-word;
}
.ant-table-row-expand-icon-cell {
  display: none;
}
.ant-hide-expand-icon-th th:first-child {
  display: none !important;
}
.ant-modal {
  overflow-y: hidden;
}
.ant-input-number-handler-wrap {
  display: none;
}
.ant-card {
  color: rgba(0, 0, 0, 0.85);
}
.ant-card-bordered {
  border: 1px solid #cfcfcf;
}
@media screen and (max-width: 600px) {
  .ant-card-body {
    padding: 10px 6px;
  }
}
.ant-input-number {
  width: 100%;
}
.ant-tooltip-inner {
  white-space: pre-wrap;
}
.ant-checkbox .ant-checkbox-inner {
  border-color: #006083;
}
.primary-color {
  color: #00739d;
}
.gray-background {
  background-color: #f7f8f9;
}
.row {
  display: flex;
  flex-direction: row;
}
.row > * {
  margin: 20px;
}
.info-banner {
  background-color: #4074CE;
  padding: 20px;
  width: 100%;
  height: auto;
  position: relative;
  display: block;
  margin: 25px 25px 0 25px;
  text-align: center;
  color: white;
  border-radius: 4px;
}
.info-banner + .millions-of-people-text {
  margin-top: 10px;
}
.info-banner-no-margin {
  background-color: #4074CE;
  padding: 20px;
  width: 100%;
  height: auto;
  position: relative;
  display: block;
  text-align: center;
  color: white;
  border-radius: 4px;
}
.fillParent {
  height: 100%;
  width: 100%;
}
.growChildren > * {
  flex-grow: 1;
}
.h3,
.form-title,
page-header {
  margin-bottom: 0.5em;
  font-weight: 500;
  font-size: 22px;
  line-height: 1.35;
  display: block;
}
.bold {
  font-weight: bold;
}
.gutter-10 > * {
  margin-right: 10px;
}
.gutter-24 > * {
  margin-right: 24px;
}
.gutter-30 > * {
  margin-right: 30px;
}
.relative-position {
  position: relative;
}
.form-title-margin {
  margin-top: 30px;
}
.suppressed {
  height: 72px;
  width: 240px;
  color: #28333F;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin: 16px;
  display: flex;
}
.panel {
  border: 1px solid #7D91AC;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(40, 51, 63, 0.24);
  padding: 10px;
  min-height: 460px;
  width: 272px;
  margin: 16px;
  background-color: #FFFFFF;
}
.retrieve-panel {
  border: 1px solid #7D91AC;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(40, 51, 63, 0.24);
  padding: 12px;
  min-height: 460px;
  width: 315px;
  margin: 16px;
  background-color: #FFFFFF;
}
.padding-10 {
  padding: 10px;
}
.padding-20 {
  padding: 20px;
}
.padding-30 {
  padding: 30px;
}
.padding-h-10 {
  padding-left: 10px;
  padding-right: 10px;
}
.padding-h-20 {
  padding-left: 20px;
  padding-right: 20px;
}
.padding-h-30 {
  padding-left: 30px;
  padding-right: 30px;
}
.padding-v-10 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.padding-v-20 {
  padding-top: 20px;
  padding-bottom: 20px;
}
.padding-v-30 {
  padding-top: 30px;
  padding-bottom: 30px;
}
.gutter-v-10 > * {
  padding-top: 10px;
  padding-bottom: 10px;
}
.millions-of-people-text {
  max-width: 912px;
  color: #28333F;
  font-size: 40px;
  font-weight: 600;
  line-height: 50px;
  text-align: center;
  margin-bottom: 80px;
  margin-top: 80px;
}
@media screen and (max-width: 500px) {
  .millions-of-people-text {
    font-size: 26px;
  }
}
.card-icon {
  width: 111px;
  height: 111px;
  margin-top: 19px;
}
.card-title {
  color: #28333F;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
}
.postal-code {
  height: 40px;
  width: 150px;
  border: 1px solid #7D91AC;
  border-radius: 4px;
  background-color: #ffffff;
}
.start-application-widget {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-left: 61px;
  margin-right: 61px;
}
.input-postal-code-text {
  text-align: center;
  height: 40px;
  width: 150px;
  border: 1px solid #7D91AC;
  border-radius: 4px;
  margin-bottom: 24px;
}
.start-quote-button {
  height: 48px;
  width: 149px;
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  text-shadow: 0 1px 2px 0 rgba(40, 51, 63, 0.16);
  margin-bottom: 25px;
}
.start-quote-button:disabled {
  background-color: rgba(0, 115, 157, 0.5);
  cursor: auto;
}
.start-quote-button:disabled:hover {
  background-color: rgba(0, 115, 157, 0.5);
  color: #ffffff;
}
.start-quote-button:hover {
  background-color: #006083;
}
.start-quote-button:active {
  background-color: #00465F;
}
.retrieve-quote-button {
  color: #00739D;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  padding: 0;
}
.retrieve-quote-button:hover {
  background-color: #F2F2F2;
}
.retrieve-quote-button:active {
  background-color: #E6E6E6;
}
.retrieve-button {
  height: 48px;
  width: 100%;
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  text-shadow: 0 1px 2px 0 rgba(40, 51, 63, 0.16);
  margin-bottom: 25px;
}
.retrieve-button:disabled {
  background-color: rgba(0, 115, 157, 0.5);
  cursor: auto;
}
.retrieve-button:disabled:hover {
  background-color: rgba(0, 115, 157, 0.5);
  color: #ffffff;
}
.retrieve-button:hover {
  background-color: #006083;
}
.retrieve-button:active {
  background-color: #00465F;
}
.ant-radio-group-solid .yes-no.ant-radio-button-wrapper:hover {
  background-color: #006083;
  color: #ffffff;
}
.ant-radio-group-solid .yes-no.ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background-color: #00739D;
}
.ant-radio-group-solid .yes-no.ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  background-color: #00739D;
}
.secondary-button:hover {
  background-color: #006083;
  color: #ffffff;
}
.secondary-button:active {
  background-color: #00465F;
  color: #ffffff;
}
.link-to-step:hover {
  color: #00739D;
}
.summary-text-group {
  display: flex;
  flex-direction: column;
  margin-right: 135px;
}
.mouse-hover:hover {
  cursor: pointer;
  color: #006083;
  background-color: #e8f9f7;
}
.mouse-hover-no-color:hover {
  cursor: pointer;
}
.mouse-hover-no-bgColor:hover {
  cursor: pointer;
  color: #006083;
  background-color: #FFFFFF;
  z-index: 3;
}
.has-interest-in-panel.ant-collapse-item-active .ant-collapse-header {
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 1rem;
}
.summary-buttons {
  background-color: #00739D;
  color: #ffffff;
  height: 30px;
  width: 30px;
  border-radius: 50%;
}
.summary-buttons:hover {
  background-color: #00465F;
  cursor: pointer;
}
.success-notification {
  background-color: #2A8440;
  padding-left: 3em!important;
  margin-bottom: 1em;
}
.success-notification .ant-alert-message {
  color: white;
}
.error-notification {
  background-color: #C4221F;
  padding-left: 3em!important;
  margin-bottom: 1em;
}
.error-notification .ant-alert-message {
  color: white;
}
.info-notification {
  background-color: #4074CE;
  padding-left: 3em!important;
  margin-bottom: 1em;
}
.info-notification .ant-alert-message {
  color: white;
}
.warning-notification {
  color: rgba(0, 0, 0, 0.65);
  background-color: #FF9D2E;
  margin-bottom: 1.5em;
  display: flex;
  padding: 12px 12px;
  border-radius: 4px;
}
.agent-error-notification {
  color: white;
  background-color: #C4221F;
  margin-bottom: 1.5em;
  display: flex;
  padding: 12px 12px;
  border-radius: 4px;
}
.agent-success-notification {
  color: white;
  background-color: #4074CE;
  margin-bottom: 1.5em;
  display: flex;
  padding: 12px 12px;
  border-radius: 4px;
}
.fieldSuccess {
  color: #2A8440;
  font-style: italic;
  font-size: 0.9em;
  position: absolute;
}
.consumer-consent-title .ant-card-meta {
  display: flex;
  align-items: center;
}
.consumer-consent-title .ant-card-meta.ant-card-meta-title {
  font-size: 24px;
}
.consumer-consent-title.ant-card-meta-title {
  font-size: 24px;
}
.return-home-link {
  font-size: 18px;
  color: #00739d;
  margin-top: 0.5em;
}
.return-home-link:hover {
  color: #006083;
}
.return-home-link:active {
  color: #00465F;
}
.ant-radio-group-solid .vehicle-type.ant-radio-button-wrapper:hover {
  background-color: white;
  color: rgba(0, 0, 0, 0.65);
  cursor: default;
}
.ant-radio-group-solid .vehicle-type.ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background-color: #00739D;
  cursor: default;
}
.ant-radio-group-solid .vehicle-type.ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  background-color: #00739D;
  color: white;
  cursor: default;
}
.form-support-text {
  margin-bottom: 32px;
  font-weight: 500;
  font-size: 20px;
  line-height: 1.35;
  display: block;
  margin-left: 32px;
}
.property-form-fields {
  margin-left: 32px;
}
.property-list-form-header .ant-collapse-header {
  font-weight: bold;
  font-size: 16px;
}
.property-list-form-header .ant-collapse .ant-collapse-item .ant-collapse-header {
  font-weight: bold;
  font-size: 14px;
}
.property-page .ant-collapse-borderless > .ant-collapse-item {
  border-bottom-width: 0;
}
.alarm-security {
  border-bottom: 1px solid grey;
}
.ant-collapse-content.ant-collapse-content-active {
  overflow: visible;
}
.dwelling-coverages {
  border-bottom: 0px;
}
.additional-coverages-modal.ant-modal {
  width: min-content;
}
.personal-auto-totals-premium {
  float: right;
  margin-right: 30px;
}
.personal-auto-totals-premium.mobile {
  margin-right: -5px;
}
#estimated-quote-text {
  font-size: 14px;
}
.bold-text {
  font-weight: bold;
}
.totals-premium-holder {
  padding: 16px;
}
.totals-premium-holder .ant-row {
  padding-top: 5px;
  padding-bottom: 5px;
}
.totals-premium-holder .quote-totals-premium {
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
}
#estimated-prem-title {
  text-align: center;
}
.renovations-description {
  margin-bottom: 15px;
}

html {
  background-color: #fff;
  font-size: 16px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  min-width: 300px;
  overflow-x: hidden;
  overflow-y: scroll;
  text-rendering: optimizeLegibility;
  font-family: 'Source Sans Pro', sans-serif;
}
article,
aside,
figure,
footer,
header,
hgroup,
section {
  display: block;
}
body,
button,
input,
select,
textarea {
  font-family: "Source Sans Pro", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
code,
pre {
  -moz-osx-font-smoothing: auto;
  -webkit-font-smoothing: auto;
  font-family: monospace;
}
body {
  color: #363636;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}
a {
  cursor: pointer;
  text-decoration: none;
  -webkit-transition: none 86ms ease-out;
  transition: none 86ms ease-out;
}
a:hover {
  color: #363636;
}
code {
  background-color: whitesmoke;
  color: #ff3860;
  font-size: 0.8em;
  font-weight: normal;
  padding: 0.25em 0.5em 0.25em;
}
hr {
  background-color: #dbdbdb;
  border: none;
  display: block;
  height: 1px;
  margin: 0.7rem 0;
}
img {
  height: auto;
  max-width: 100%;
}
input[type="checkbox"],
input[type="radio"] {
  vertical-align: baseline;
}
small {
  font-size: 0.875em;
}
span {
  font-style: inherit;
  font-weight: inherit;
}
strong {
  color: #363636;
  font-weight: 700;
}
pre {
  background-color: whitesmoke;
  color: #363636;
  font-size: 0.8em;
  white-space: pre;
  word-wrap: normal;
}
pre code {
  -webkit-overflow-scrolling: touch;
  background: none;
  color: inherit;
  display: block;
  font-size: 1em;
  overflow-x: auto;
  padding: 1.25rem 1.5rem;
}
table,
.table {
  width: 100%;
}
table td,
table th,
.table .td {
  text-align: left;
  vertical-align: top;
  padding: 0.5em 0.75em;
}
table th,
.thead .td {
  color: #363636;
}
.btn-group {
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
}
.cancel-button {
  color: #00739d;
  background-color: #ffffff;
  border: none;
}
.cancel-button:hover {
  cursor: pointer;
  background-color: #f2f2f2;
  height: 32px;
}
.fieldError {
  color: salmon;
  font-style: italic;
  font-size: 0.9em;
  position: absolute;
}
.form-disabling-overlay {
  position: absolute;
  z-index: 999;
  background-color: white;
  opacity: 0.5;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.coverage-table .coverage-table-input {
  width: 105px;
}
.coverage-table.mobile .coverage-detail-row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: center;
  padding: 8px 16px;
}
.coverage-table.mobile .coverage-detail-row:nth-child(odd) {
  background: #f8f9fa;
}
.coverage-table.mobile .coverage-detail-row:only-child {
  background: #ffffff;
}
.coverage-table.mobile .ant-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.coverage-table.mobile .label {
  display: flex;
  justify-content: flex-start;
}
.coverage-table.mobile .field {
  display: flex;
  justify-content: flex-end;
  font-weight: bold;
  text-align: right;
}
.coverage-table.desktop .label {
  font-weight: bold;
}
.medical-payments-written-premium {
  font-size: 12px;
}
.deduction-value-panel .field-label-col {
  margin-right: 10px;
}
.coverage-table-summary {
  padding: 16px;
}
.coverage-table-summary > #coverage-summary-table-header {
  font-weight: bold;
}
.coverage-table-summary .coverage-detail-row {
  padding: 8px 16px;
}
.coverage-table-summary .coverage-detail-row > .ant-row {
  margin-bottom: 10px;
}
.coverage-table-summary .description-col {
  word-break: break-word;
}
.coverage-table-summary .limit-col {
  text-align: end;
  word-break: break-word;
}
.coverage-table-summary .premium-col {
  text-align: end;
}
.coverage-table-summary.mobile .coverage-detail-row:nth-child(odd) {
  background: #f8f9fa;
}
.coverage-table-summary.mobile .description-col {
  text-align: end;
  font-weight: bold;
}
.checkbox-input {
  display: flex;
}
.checkbox-input > .field-label-col {
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./modules/portal-core/styles/antd-restyle.less","webpack://./modules/portal-core/styles/index.less","webpack://./modules/portal-core/styles/common.less","webpack://./modules/portal-core/styles/reset/typography.less","webpack://./modules/portal-core/styles/buttons.less","webpack://./modules/portal-core/styles/form.less","webpack://./modules/portal-core/components/forms/coverages/CoverageTable.less","webpack://./modules/portal-core/components/forms/coverages/CoverageTableSummary.less","webpack://./modules/portal-core/styles/inputs.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;ACCF;ADFA;EAGI,qBAAA;EACA,gBAAA;EACA,kBAAA;ACEJ;ADDI;EACE,wBAAA;ACGN;ADyBA;EACE,gBAAA;ACvBF;AD8BA;EAEE,cAAA;EACA,iFAAA;EACA,YAAA;AC7BF;ADgCA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AC9BF;AD+BE;EACE,yBAAA;AC7BJ;AD+BE;EACE,yBAAA;EACA,gBAAA;AC7BJ;ADiCA;EACE,wBAAA;AC/BF;ADkCA;EACE,kDAAA;EACA,cAAA;AChCF;ADiCE;EACE,wCAAA;EACA,cAAA;EACA,YAAA;AC/BJ;ADgCI;EACE,wCAAA;EACA,cAAA;AC9BN;ADiCE;EACE,yBAAA;AC/BJ;ADiCE;EACE,yBAAA;AC/BJ;ADoCA;EACE,yBAAA;AClCF;ADqCA;EACE,WAAA;EACA,qBAAA;ACnCF;ADsCA;EACE,aAAA;ACpCF;ADuCA;EACE,wBAAA;ACrCF;ADwCA;EACE,kBAAA;ACtCF;ADyCA;EACE,aAAA;ACvCF;AD0CA;EACE,0BAAA;ACxCF;AD2CA;EACE,yBAAA;ACzCF;AD6CE;EAAA;IACE,iBAAA;EC1CF;AACF;AD6CA;EACE,WAAA;AC3CF;AD8CA;EACE,qBAAA;AC5CF;AD+CA;EACE,qBAAA;AC7CF;AC7FA;EACE,cAAA;AD+FF;AC5FA;EACE,yBAAA;AD8FF;AC3FA;EACE,aAAA;EACA,mBAAA;AD6FF;AC5FE;EACE,YAAA;AD8FJ;AC1FA;EACE,yBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AD4FF;AC1FA;EACE,gBAAA;AD4FF;ACzFA;EACE,yBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AD2FF;ACxFA;EACE,YAAA;EACA,WAAA;AD0FF;ACtFE;EACE,YAAA;ADwFJ;ACpFA;;;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ADwFF;ACrFA;EACE,iBAAA;ADuFF;ACpFA;EACE,kBAAA;ADsFF;ACnFA;EACE,kBAAA;ADqFF;AClFA;EACG,kBAAA;ADoFH;ACjFA;EACE,kBAAA;ADmFF;AChFA;EACE,gBAAA;ADkFF;AC/EA;EACE,YAAA;EACA,YAAA;EACA,cAAA;EAEA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;ADgFF;AC7EA;EACE,yBAAA;EACA,kBAAA;EACA,8CAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AD+EF;AC5EA;EACE,yBAAA;EACA,kBAAA;EACA,8CAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AD8EF;AC3EA;EAAa,aAAA;AD8Eb;AC7EA;EAAa,aAAA;ADgFb;AC/EA;EAAa,aAAA;ADkFb;AC/EA;EAAe,kBAAA;EAAoB,mBAAA;ADmFnC;AClFA;EAAe,kBAAA;EAAoB,mBAAA;ADsFnC;ACrFA;EAAe,kBAAA;EAAoB,mBAAA;ADyFnC;ACvFA;EAAe,iBAAA;EAAmB,oBAAA;AD2FlC;AC1FA;EAAe,iBAAA;EAAmB,oBAAA;AD8FlC;AC7FA;EAAe,iBAAA;EAAmB,oBAAA;ADiGlC;AC7FE;EANa,iBAAA;EAAmB,oBAAA;ADuGlC;AC7FA;EACE,gBAAA;EACA,cAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AD8FF;AC7FE;EAAA;IACE,eAAA;EDgGF;AACF;AC7FA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;AD+FF;AC5FA;EAGE,cAAA;EAEA,eAAA;EACA,gBAAA;EAEA,kBAAA;AD0FF;ACtFA;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;ADwFF;ACrFA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ADuFF;ACpFA;EAEE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;ADqFF;AClFA;EACE,YAAA;EACA,YAAA;EACA,cAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,+CAAA;EACA,mBAAA;ADmFF;AClFE;EACE,wCAAA;EACA,YAAA;ADoFJ;ACnFI;EACE,wCAAA;EACA,cAAA;ADqFN;AClFE;EACE,yBAAA;ADoFJ;AClFE;EACE,yBAAA;ADoFJ;AChFA;EACE,cAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EAOA,UAAA;AD2EF;ACjFE;EACE,yBAAA;ADmFJ;ACjFE;EACE,yBAAA;ADmFJ;AC9EA;EACE,YAAA;EACA,WAAA;EACA,cAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,+CAAA;EACA,mBAAA;AD+EF;AC9EE;EACE,wCAAA;EACA,YAAA;ADgFJ;AC/EI;EACE,wCAAA;EACA,cAAA;ADiFN;AC9EE;EACE,yBAAA;ADgFJ;AC9EE;EACE,yBAAA;ADgFJ;AC3EE;EACE,yBAAA;EACA,cAAA;AD6EJ;AC3EE;EACE,yBAAA;AD6EJ;AC5EI;EACE,yBAAA;AD8EN;ACxEE;EACE,yBAAA;EACA,cAAA;AD0EJ;ACxEE;EACE,yBAAA;EACA,cAAA;AD0EJ;ACrEE;EACE,cAAA;ADuEJ;ACnEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;ADqEF;AClEA;EACE,eAAA;EACA,cAAA;EACA,yBAAA;ADoEF;ACjEA;EACE,eAAA;ADmEF;AChEA;EACE,eAAA;EACA,cAAA;EACA,yBAAA;EACA,UAAA;ADkEF;AC/DA;EACE,gCAAA;EACA,mBAAA;ADiEF;AC9DA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;ADgEF;AC/DE;EACE,yBAAA;EACA,eAAA;ADiEJ;AC7DA;EAIE,yBAAA;EACA,2BAAA;EACA,kBAAA;AD4DF;AClEA;EAEI,YAAA;ADmEJ;AC5DA;EAIE,yBAAA;EACA,2BAAA;EACA,kBAAA;AD2DF;ACjEA;EAEI,YAAA;ADkEJ;AC1DA;EAIE,yBAAA;EACA,2BAAA;EACA,kBAAA;ADyDF;AC/DA;EAEI,YAAA;ADgEJ;ACzDA;EACE,0BAAA;EACA,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AD2DF;ACxDA;EACE,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AD0DF;ACvDA;EACE,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;ADyDF;ACtDA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;ADwDF;ACrDA;EAIE,aAAA;EACA,mBAAA;ADoDF;ACxDE;EACE,eAAA;AD0DJ;ACpDA;EACI,eAAA;ADsDJ;ACnDA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;ADqDF;ACpDE;EACE,cAAA;ADsDJ;ACpDE;EACE,cAAA;ADsDJ;ACjDE;EACE,uBAAA;EACA,0BAAA;EACA,eAAA;ADmDJ;ACjDE;EACE,yBAAA;EACA,eAAA;ADmDJ;AClDI;EACE,yBAAA;EACA,YAAA;EACA,eAAA;ADoDN;AC/CA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;ADiDF;AC9CA;EACE,iBAAA;ADgDF;AC7CA;EAEI,iBAAA;EACA,eAAA;AD8CJ;ACjDA;EAMI,iBAAA;EACA,eAAA;AD8CJ;AC1CA;EACE,sBAAA;AD4CF;ACzCA;EACE,6BAAA;AD2CF;ACxCA;EACE,iBAAA;AD0CF;ACvCA;EACE,kBAAA;ADyCF;ACtCA;EACE,kBAAA;ADwCF;ACrCA;EACE,YAAA;EACA,kBAAA;ADuCF;ACtCE;EACE,kBAAA;ADwCJ;ACpCA;EACE,eAAA;ADsCF;ACnCA;EACE,iBAAA;ADqCF;AClCA;EACE,aAAA;ADoCF;ACrCA;EAGI,gBAAA;EACA,mBAAA;ADqCJ;ACzCA;EAOI,iBAAA;EACA,aAAA;EACA,yBAAA;ADqCJ;ACjCA;EACE,kBAAA;ADmCF;AChCA;EACE,mBAAA;ADkCF;;AEziBA;EACE,sBAAA;EACA,eAAA;EACA,kCAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kCAAA;EACA,0CAAA;AF6iBF;AE1iBA;;;;;;;EAOE,cAAA;AF4iBF;AEziBA;;;;;EAKE,uMAAA;AF2iBF;AExiBA;;EAEE,6BAAA;EACA,4BAAA;EACA,sBAAA;AF0iBF;AEviBA;EACE,cAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AFyiBF;AEtiBA;EACE,eAAA;EACA,qBAAA;EACA,sCAAA;EACA,8BAAA;AFwiBF;AEriBA;EACE,cAAA;AFuiBF;AEpiBA;EACE,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;AFsiBF;AEniBA;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;AFqiBF;AEliBA;EACE,YAAA;EACA,eAAA;AFoiBF;AEjiBA;;EAEE,wBAAA;AFmiBF;AEhiBA;EACE,kBAAA;AFkiBF;AE/hBA;EACE,mBAAA;EACA,oBAAA;AFiiBF;AE9hBA;EACE,cAAA;EACA,gBAAA;AFgiBF;AE7hBA;EACE,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AF+hBF;AE5hBA;EACE,iCAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AF8hBF;AE3hBA;;EACE,WAAA;AF8hBF;AE3hBA;;;EAGE,gBAAA;EACA,mBAAA;EACA,qBAAA;AF6hBF;AE1hBA;;EACE,cAAA;AF6hBF;AG9pBA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AHgqBF;AG7pBA;EACE,cAAA;EACA,yBAAA;EACA,YAAA;AH+pBF;AG5pBA;EACE,eAAA;EACA,yBAAA;EACA,YAAA;AH8pBF;AI7qBA;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AJ+qBF;AI5qBA;EACE,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;AJ8qBF;AK5rBA;EAEI,YAAA;AL6rBJ;AK3rBE;EAEI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;AL4rBN;AKlsBE;EASI,mBAAA;AL4rBN;AKrsBE;EAYI,mBAAA;AL4rBN;AKxsBE;EAeI,aAAA;EACA,mBAAA;EACA,mBAAA;AL4rBN;AK7sBE;EAoBI,aAAA;EACA,2BAAA;AL4rBN;AKjtBE;EAwBI,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;AL4rBN;AKzrBE;EAEI,iBAAA;AL0rBN;AKrrBA;EACE,eAAA;ALurBF;AKprBA;EAEI,kBAAA;ALqrBJ;AMruBA;EACE,aAAA;ANuuBF;AMxuBA;EAII,iBAAA;ANuuBJ;AM3uBA;EAOI,iBAAA;ANuuBJ;AM9uBA;EASM,mBAAA;ANwuBN;AMjvBA;EAaI,sBAAA;ANuuBJ;AMpvBA;EAiBI,eAAA;EACA,sBAAA;ANsuBJ;AMxvBA;EAsBI,eAAA;ANquBJ;AMjuBA;EAEI,mBAAA;ANkuBJ;AMpuBA;EAKI,eAAA;EACA,iBAAA;ANkuBJ;AOlwBA;EACE,aAAA;APowBF;AOrwBA;EAGI,iBAAA;APqwBJ","sourcesContent":[".ant-form-item-label {\n  white-space: normal;\n  label {\n    display: inline-block;\n    line-height: 1.3;\n    margin-right: 12px;\n    &:after {\n      content: none !important;\n    }\n  }\n}\n\n* {\n  //animation-duration: 500ms !important;\n}\n\n@text-primary-color: #28333F;\n\n@navigation-hover-background: #e8f9f7;\n\n@button-primary-color: rgb(255, 255, 255);\n\n@button-primary-bg-image: linear-gradient(\n  240deg,\n  rgb(0, 134, 182),\n  rgb(0, 115, 157)\n);\n@button-primary-border-color: rgb(0, 115, 157);\n@button-primary-box-shadow: rgba(40, 51, 63, 0.16) 0px 0px 1px 1px inset;\n@button-primary-background-color: #00739D;\n@button-primary-disabled-color:  rgba(0, 115, 157, 0.5);\n@button-primary-hover-color: #006083;\n@button-primary-active-color: #00465F;\n@button-tertiary-hover-color: #F2F2F2;\n@button-tertiary-active-color: #E6E6E6 ;\n.ant-btn {\n  font-weight: 600;\n  //color: @button-primary-color;\n  //background-image: @button-primary-bg-image;\n  //border-color: @button-primary-border-color;\n  //box-shadow: @button-primary-box-shadow;\n}\n\n.ant-btn {\n  //border: 2px;\n  color: @button-primary-background-color;\n  box-shadow:rgb(0, 134, 182) 0px 0px 0px 2px inset, rgba(40, 51, 63, 0.16) 0px 2px 4px 0px;\n  border: none;\n}\n\n.ant-btn.ant-btn-link {\n  box-shadow: none;\n  color: @button-primary-background-color;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n  text-align: center;\n  &:hover {\n    background-color: @button-tertiary-hover-color\n  }\n  &:active {\n    background-color: @button-tertiary-active-color;\n    font-weight: 600;\n  }\n}\n\n.ant-btn:focus-visible{\n  border: 2px orange solid;\n}\n\n.ant-btn.ant-btn-primary {\n  box-shadow: rgba(40, 51, 63, 0.16) 0px 2px 4px 0px;\n  color: @button-primary-color;\n  &:disabled {\n    background-color:@button-primary-disabled-color;\n    color: @button-primary-color;\n    cursor: auto;\n    &:hover {\n      background-color: @button-primary-disabled-color;\n      color: @button-primary-color;\n    }\n  }\n  &:hover {\n    background-color: @button-primary-hover-color\n  }\n  &:active {\n    background-color: @button-primary-active-color\n  }\n}\n\n\n.ant-collapse-header {\n  background-color: #ffffff;\n}\n\n.ant-radio-group {\n  width: 100%;\n  word-wrap: break-word;\n}\n\n.ant-table-row-expand-icon-cell {\n  display: none;\n}\n\n.ant-hide-expand-icon-th th:first-child {\n  display: none !important;\n}\n\n.ant-modal {\n  overflow-y: hidden;\n}\n\n.ant-input-number-handler-wrap {\n  display: none;\n}\n\n.ant-card {\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.ant-card-bordered {\n  border: 1px solid #cfcfcf;\n}\n\n.ant-card-body {\n  @media screen and (max-width: 600px) {\n    padding: 10px 6px;\n  }\n}\n\n.ant-input-number{\n  width: 100%;\n}\n\n.ant-tooltip-inner {\n  white-space: pre-wrap;\n}\n\n.ant-checkbox .ant-checkbox-inner {\n  border-color: @button-primary-hover-color;\n}",".ant-form-item-label {\n  white-space: normal;\n}\n.ant-form-item-label label {\n  display: inline-block;\n  line-height: 1.3;\n  margin-right: 12px;\n}\n.ant-form-item-label label:after {\n  content: none !important;\n}\n.ant-btn {\n  font-weight: 600;\n}\n.ant-btn {\n  color: #00739D;\n  box-shadow: #0086b6 0px 0px 0px 2px inset, rgba(40, 51, 63, 0.16) 0px 2px 4px 0px;\n  border: none;\n}\n.ant-btn.ant-btn-link {\n  box-shadow: none;\n  color: #00739D;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n  text-align: center;\n}\n.ant-btn.ant-btn-link:hover {\n  background-color: #F2F2F2;\n}\n.ant-btn.ant-btn-link:active {\n  background-color: #E6E6E6;\n  font-weight: 600;\n}\n.ant-btn:focus-visible {\n  border: 2px orange solid;\n}\n.ant-btn.ant-btn-primary {\n  box-shadow: rgba(40, 51, 63, 0.16) 0px 2px 4px 0px;\n  color: #ffffff;\n}\n.ant-btn.ant-btn-primary:disabled {\n  background-color: rgba(0, 115, 157, 0.5);\n  color: #ffffff;\n  cursor: auto;\n}\n.ant-btn.ant-btn-primary:disabled:hover {\n  background-color: rgba(0, 115, 157, 0.5);\n  color: #ffffff;\n}\n.ant-btn.ant-btn-primary:hover {\n  background-color: #006083;\n}\n.ant-btn.ant-btn-primary:active {\n  background-color: #00465F;\n}\n.ant-collapse-header {\n  background-color: #ffffff;\n}\n.ant-radio-group {\n  width: 100%;\n  word-wrap: break-word;\n}\n.ant-table-row-expand-icon-cell {\n  display: none;\n}\n.ant-hide-expand-icon-th th:first-child {\n  display: none !important;\n}\n.ant-modal {\n  overflow-y: hidden;\n}\n.ant-input-number-handler-wrap {\n  display: none;\n}\n.ant-card {\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-card-bordered {\n  border: 1px solid #cfcfcf;\n}\n@media screen and (max-width: 600px) {\n  .ant-card-body {\n    padding: 10px 6px;\n  }\n}\n.ant-input-number {\n  width: 100%;\n}\n.ant-tooltip-inner {\n  white-space: pre-wrap;\n}\n.ant-checkbox .ant-checkbox-inner {\n  border-color: #006083;\n}\n.primary-color {\n  color: #00739d;\n}\n.gray-background {\n  background-color: #f7f8f9;\n}\n.row {\n  display: flex;\n  flex-direction: row;\n}\n.row > * {\n  margin: 20px;\n}\n.info-banner {\n  background-color: #4074CE;\n  padding: 20px;\n  width: 100%;\n  height: auto;\n  position: relative;\n  display: block;\n  margin: 25px 25px 0 25px;\n  text-align: center;\n  color: white;\n  border-radius: 4px;\n}\n.info-banner + .millions-of-people-text {\n  margin-top: 10px;\n}\n.info-banner-no-margin {\n  background-color: #4074CE;\n  padding: 20px;\n  width: 100%;\n  height: auto;\n  position: relative;\n  display: block;\n  text-align: center;\n  color: white;\n  border-radius: 4px;\n}\n.fillParent {\n  height: 100%;\n  width: 100%;\n}\n.growChildren > * {\n  flex-grow: 1;\n}\n.h3,\n.form-title,\npage-header {\n  margin-bottom: 0.5em;\n  font-weight: 500;\n  font-size: 22px;\n  line-height: 1.35;\n  display: block;\n}\n.bold {\n  font-weight: bold;\n}\n.gutter-10 > * {\n  margin-right: 10px;\n}\n.gutter-24 > * {\n  margin-right: 24px;\n}\n.gutter-30 > * {\n  margin-right: 30px;\n}\n.relative-position {\n  position: relative;\n}\n.form-title-margin {\n  margin-top: 30px;\n}\n.suppressed {\n  height: 72px;\n  width: 240px;\n  color: #28333F;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  margin: 16px;\n  display: flex;\n}\n.panel {\n  border: 1px solid #7D91AC;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px 0 rgba(40, 51, 63, 0.24);\n  padding: 10px;\n  min-height: 460px;\n  width: 272px;\n  margin: 16px;\n  background-color: #FFFFFF;\n}\n.retrieve-panel {\n  border: 1px solid #7D91AC;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px 0 rgba(40, 51, 63, 0.24);\n  padding: 12px;\n  min-height: 460px;\n  width: 315px;\n  margin: 16px;\n  background-color: #FFFFFF;\n}\n.padding-10 {\n  padding: 10px;\n}\n.padding-20 {\n  padding: 20px;\n}\n.padding-30 {\n  padding: 30px;\n}\n.padding-h-10 {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.padding-h-20 {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.padding-h-30 {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n.padding-v-10 {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.padding-v-20 {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.padding-v-30 {\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n.gutter-v-10 > * {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.millions-of-people-text {\n  max-width: 912px;\n  color: #28333F;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 50px;\n  text-align: center;\n  margin-bottom: 80px;\n  margin-top: 80px;\n}\n@media screen and (max-width: 500px) {\n  .millions-of-people-text {\n    font-size: 26px;\n  }\n}\n.card-icon {\n  width: 111px;\n  height: 111px;\n  margin-top: 19px;\n}\n.card-title {\n  color: #28333F;\n  font-size: 24px;\n  font-weight: 600;\n  text-align: center;\n}\n.postal-code {\n  height: 40px;\n  width: 150px;\n  border: 1px solid #7D91AC;\n  border-radius: 4px;\n  background-color: #ffffff;\n}\n.start-application-widget {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin-left: 61px;\n  margin-right: 61px;\n}\n.input-postal-code-text {\n  text-align: center;\n  height: 40px;\n  width: 150px;\n  border: 1px solid #7D91AC;\n  border-radius: 4px;\n  margin-bottom: 24px;\n}\n.start-quote-button {\n  height: 48px;\n  width: 149px;\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  text-align: center;\n  text-shadow: 0 1px 2px 0 rgba(40, 51, 63, 0.16);\n  margin-bottom: 25px;\n}\n.start-quote-button:disabled {\n  background-color: rgba(0, 115, 157, 0.5);\n  cursor: auto;\n}\n.start-quote-button:disabled:hover {\n  background-color: rgba(0, 115, 157, 0.5);\n  color: #ffffff;\n}\n.start-quote-button:hover {\n  background-color: #006083;\n}\n.start-quote-button:active {\n  background-color: #00465F;\n}\n.retrieve-quote-button {\n  color: #00739D;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  text-align: center;\n  padding: 0;\n}\n.retrieve-quote-button:hover {\n  background-color: #F2F2F2;\n}\n.retrieve-quote-button:active {\n  background-color: #E6E6E6;\n}\n.retrieve-button {\n  height: 48px;\n  width: 100%;\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  text-align: center;\n  text-shadow: 0 1px 2px 0 rgba(40, 51, 63, 0.16);\n  margin-bottom: 25px;\n}\n.retrieve-button:disabled {\n  background-color: rgba(0, 115, 157, 0.5);\n  cursor: auto;\n}\n.retrieve-button:disabled:hover {\n  background-color: rgba(0, 115, 157, 0.5);\n  color: #ffffff;\n}\n.retrieve-button:hover {\n  background-color: #006083;\n}\n.retrieve-button:active {\n  background-color: #00465F;\n}\n.ant-radio-group-solid .yes-no.ant-radio-button-wrapper:hover {\n  background-color: #006083;\n  color: #ffffff;\n}\n.ant-radio-group-solid .yes-no.ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  background-color: #00739D;\n}\n.ant-radio-group-solid .yes-no.ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {\n  background-color: #00739D;\n}\n.secondary-button:hover {\n  background-color: #006083;\n  color: #ffffff;\n}\n.secondary-button:active {\n  background-color: #00465F;\n  color: #ffffff;\n}\n.link-to-step:hover {\n  color: #00739D;\n}\n.summary-text-group {\n  display: flex;\n  flex-direction: column;\n  margin-right: 135px;\n}\n.mouse-hover:hover {\n  cursor: pointer;\n  color: #006083;\n  background-color: #e8f9f7;\n}\n.mouse-hover-no-color:hover {\n  cursor: pointer;\n}\n.mouse-hover-no-bgColor:hover {\n  cursor: pointer;\n  color: #006083;\n  background-color: #FFFFFF;\n  z-index: 3;\n}\n.has-interest-in-panel.ant-collapse-item-active .ant-collapse-header {\n  border-bottom: 1px solid #d9d9d9;\n  margin-bottom: 1rem;\n}\n.summary-buttons {\n  background-color: #00739D;\n  color: #ffffff;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n}\n.summary-buttons:hover {\n  background-color: #00465F;\n  cursor: pointer;\n}\n.success-notification {\n  background-color: #2A8440;\n  padding-left: 3em!important;\n  margin-bottom: 1em;\n}\n.success-notification .ant-alert-message {\n  color: white;\n}\n.error-notification {\n  background-color: #C4221F;\n  padding-left: 3em!important;\n  margin-bottom: 1em;\n}\n.error-notification .ant-alert-message {\n  color: white;\n}\n.info-notification {\n  background-color: #4074CE;\n  padding-left: 3em!important;\n  margin-bottom: 1em;\n}\n.info-notification .ant-alert-message {\n  color: white;\n}\n.warning-notification {\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #FF9D2E;\n  margin-bottom: 1.5em;\n  display: flex;\n  padding: 12px 12px;\n  border-radius: 4px;\n}\n.agent-error-notification {\n  color: white;\n  background-color: #C4221F;\n  margin-bottom: 1.5em;\n  display: flex;\n  padding: 12px 12px;\n  border-radius: 4px;\n}\n.agent-success-notification {\n  color: white;\n  background-color: #4074CE;\n  margin-bottom: 1.5em;\n  display: flex;\n  padding: 12px 12px;\n  border-radius: 4px;\n}\n.fieldSuccess {\n  color: #2A8440;\n  font-style: italic;\n  font-size: 0.9em;\n  position: absolute;\n}\n.consumer-consent-title .ant-card-meta {\n  display: flex;\n  align-items: center;\n}\n.consumer-consent-title .ant-card-meta.ant-card-meta-title {\n  font-size: 24px;\n}\n.consumer-consent-title.ant-card-meta-title {\n  font-size: 24px;\n}\n.return-home-link {\n  font-size: 18px;\n  color: #00739d;\n  margin-top: 0.5em;\n}\n.return-home-link:hover {\n  color: #006083;\n}\n.return-home-link:active {\n  color: #00465F;\n}\n.ant-radio-group-solid .vehicle-type.ant-radio-button-wrapper:hover {\n  background-color: white;\n  color: rgba(0, 0, 0, 0.65);\n  cursor: default;\n}\n.ant-radio-group-solid .vehicle-type.ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  background-color: #00739D;\n  cursor: default;\n}\n.ant-radio-group-solid .vehicle-type.ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {\n  background-color: #00739D;\n  color: white;\n  cursor: default;\n}\n.form-support-text {\n  margin-bottom: 32px;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 1.35;\n  display: block;\n  margin-left: 32px;\n}\n.property-form-fields {\n  margin-left: 32px;\n}\n.property-list-form-header .ant-collapse-header {\n  font-weight: bold;\n  font-size: 16px;\n}\n.property-list-form-header .ant-collapse .ant-collapse-item .ant-collapse-header {\n  font-weight: bold;\n  font-size: 14px;\n}\n.property-page .ant-collapse-borderless > .ant-collapse-item {\n  border-bottom-width: 0;\n}\n.alarm-security {\n  border-bottom: 1px solid grey;\n}\n.ant-collapse-content.ant-collapse-content-active {\n  overflow: visible;\n}\n.dwelling-coverages {\n  border-bottom: 0px;\n}\n.additional-coverages-modal.ant-modal {\n  width: min-content;\n}\n.personal-auto-totals-premium {\n  float: right;\n  margin-right: 30px;\n}\n.personal-auto-totals-premium.mobile {\n  margin-right: -5px;\n}\n#estimated-quote-text {\n  font-size: 14px;\n}\n.bold-text {\n  font-weight: bold;\n}\n.totals-premium-holder {\n  padding: 16px;\n}\n.totals-premium-holder .ant-row {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n.totals-premium-holder .quote-totals-premium {\n  font-weight: bold;\n  display: flex;\n  justify-content: flex-end;\n}\n#estimated-prem-title {\n  text-align: center;\n}\n.renovations-description {\n  margin-bottom: 15px;\n}\n@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro&display=swap');\n\nhtml {\n  background-color: #fff;\n  font-size: 16px;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  min-width: 300px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  text-rendering: optimizeLegibility;\n  font-family: 'Source Sans Pro', sans-serif;\n}\narticle,\naside,\nfigure,\nfooter,\nheader,\nhgroup,\nsection {\n  display: block;\n}\nbody,\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: \"Source Sans Pro\", BlinkMacSystemFont, -apple-system, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n}\ncode,\npre {\n  -moz-osx-font-smoothing: auto;\n  -webkit-font-smoothing: auto;\n  font-family: monospace;\n}\nbody {\n  color: #363636;\n  font-family: 'Source Sans Pro';\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\na {\n  cursor: pointer;\n  text-decoration: none;\n  -webkit-transition: none 86ms ease-out;\n  transition: none 86ms ease-out;\n}\na:hover {\n  color: #363636;\n}\ncode {\n  background-color: whitesmoke;\n  color: #ff3860;\n  font-size: 0.8em;\n  font-weight: normal;\n  padding: 0.25em 0.5em 0.25em;\n}\nhr {\n  background-color: #dbdbdb;\n  border: none;\n  display: block;\n  height: 1px;\n  margin: 0.7rem 0;\n}\nimg {\n  height: auto;\n  max-width: 100%;\n}\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  vertical-align: baseline;\n}\nsmall {\n  font-size: 0.875em;\n}\nspan {\n  font-style: inherit;\n  font-weight: inherit;\n}\nstrong {\n  color: #363636;\n  font-weight: 700;\n}\npre {\n  background-color: whitesmoke;\n  color: #363636;\n  font-size: 0.8em;\n  white-space: pre;\n  word-wrap: normal;\n}\npre code {\n  -webkit-overflow-scrolling: touch;\n  background: none;\n  color: inherit;\n  display: block;\n  font-size: 1em;\n  overflow-x: auto;\n  padding: 1.25rem 1.5rem;\n}\ntable,\n.table {\n  width: 100%;\n}\ntable td,\ntable th,\n.table .td {\n  text-align: left;\n  vertical-align: top;\n  padding: 0.5em 0.75em;\n}\ntable th,\n.thead .td {\n  color: #363636;\n}\n.btn-group {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 28px;\n}\n.cancel-button {\n  color: #00739d;\n  background-color: #ffffff;\n  border: none;\n}\n.cancel-button:hover {\n  cursor: pointer;\n  background-color: #f2f2f2;\n  height: 32px;\n}\n.fieldError {\n  color: salmon;\n  font-style: italic;\n  font-size: 0.9em;\n  position: absolute;\n}\n.form-disabling-overlay {\n  position: absolute;\n  z-index: 999;\n  background-color: white;\n  opacity: 0.5;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n.coverage-table .coverage-table-input {\n  width: 105px;\n}\n.coverage-table.mobile .coverage-detail-row {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-content: center;\n  padding: 8px 16px;\n}\n.coverage-table.mobile .coverage-detail-row:nth-child(odd) {\n  background: #f8f9fa;\n}\n.coverage-table.mobile .coverage-detail-row:only-child {\n  background: #ffffff;\n}\n.coverage-table.mobile .ant-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n.coverage-table.mobile .label {\n  display: flex;\n  justify-content: flex-start;\n}\n.coverage-table.mobile .field {\n  display: flex;\n  justify-content: flex-end;\n  font-weight: bold;\n  text-align: right;\n}\n.coverage-table.desktop .label {\n  font-weight: bold;\n}\n.medical-payments-written-premium {\n  font-size: 12px;\n}\n.deduction-value-panel .field-label-col {\n  margin-right: 10px;\n}\n.coverage-table-summary {\n  padding: 16px;\n}\n.coverage-table-summary > #coverage-summary-table-header {\n  font-weight: bold;\n}\n.coverage-table-summary .coverage-detail-row {\n  padding: 8px 16px;\n}\n.coverage-table-summary .coverage-detail-row > .ant-row {\n  margin-bottom: 10px;\n}\n.coverage-table-summary .description-col {\n  word-break: break-word;\n}\n.coverage-table-summary .limit-col {\n  text-align: end;\n  word-break: break-word;\n}\n.coverage-table-summary .premium-col {\n  text-align: end;\n}\n.coverage-table-summary.mobile .coverage-detail-row:nth-child(odd) {\n  background: #f8f9fa;\n}\n.coverage-table-summary.mobile .description-col {\n  text-align: end;\n  font-weight: bold;\n}\n.checkbox-input {\n  display: flex;\n}\n.checkbox-input > .field-label-col {\n  margin-left: 10px;\n}\n","\n.primary-color {\n  color: @primary-color;\n}\n\n.gray-background {\n  background-color: @color-body-bg;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  & > * {\n    margin: 20px;\n  }\n}\n\n.info-banner {\n  background-color: @gw-color-alert-info;\n  padding: 20px;\n  width: 100%;\n  height: auto;\n  position: relative;\n  display: block;\n  margin: 25px 25px 0 25px;\n  text-align: center;\n  color: white;\n  border-radius: 4px;\n}\n.info-banner + .millions-of-people-text {\n  margin-top: 10px;\n}\n\n.info-banner-no-margin {\n  background-color: @gw-color-alert-info;\n  padding: 20px;\n  width: 100%;\n  height: auto;\n  position: relative;\n  display: block;\n  text-align: center;\n  color: white;\n  border-radius: 4px;\n}\n\n.fillParent {\n  height: 100%;\n  width: 100%;\n}\n\n.growChildren {\n  & > * {\n    flex-grow: 1;\n  }\n}\n\n.h3, .form-title, page-header {\n  margin-bottom: 0.5em;\n  font-weight: 500;\n  font-size: 22px;\n  line-height: 1.35;\n  display: block;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.gutter-10 > * {\n  margin-right: 10px;\n}\n\n.gutter-24 > * {\n  margin-right: 24px;\n}\n\n.gutter-30 > * {\n   margin-right: 30px;\n }\n\n.relative-position {\n  position: relative;\n}\n\n.form-title-margin {\n  margin-top: 30px;\n}\n\n.suppressed {\n  height: 72px;\n  width: 240px;\n  color: @text-primary-color;\n  //font-family: \"Source Sans Pro\";\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  margin: 16px;\n  display: flex;\n}\n\n.panel {\n  border: 1px solid #7D91AC;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px 0 rgba(40,51,63,0.24);\n  padding: 10px;\n  min-height: 460px;\n  width: 272px;\n  margin: 16px;\n  background-color: @color-bg;\n}\n\n.retrieve-panel {\n  border: 1px solid #7D91AC;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px 0 rgba(40,51,63,0.24);\n  padding: 12px;\n  min-height: 460px;\n  width: 315px;\n  margin: 16px;\n  background-color: @color-bg;\n}\n\n.padding-10 {padding: 10px;}\n.padding-20 {padding: 20px;}\n.padding-30 {padding: 30px;}\n\n\n.padding-h-10 {padding-left: 10px; padding-right: 10px;}\n.padding-h-20 {padding-left: 20px; padding-right: 20px;}\n.padding-h-30 {padding-left: 30px; padding-right: 30px;}\n\n.padding-v-10 {padding-top: 10px; padding-bottom: 10px;}\n.padding-v-20 {padding-top: 20px; padding-bottom: 20px;}\n.padding-v-30 {padding-top: 30px; padding-bottom: 30px;}\n\n\n.gutter-v-10  {\n  & > * {.padding-v-10}\n}\n\n\n.millions-of-people-text {\n  max-width: 912px;\n  color: @text-primary-color;\n  //font-family: \"Source Sans Pro\";\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 50px;\n  text-align: center;\n  margin-bottom: 80px;\n  margin-top: 80px;\n  @media screen and (max-width: 500px) {\n    font-size: 26px;\n  }\n}\n\n.card-icon {\n  width: 111px;\n  height: 111px;\n  margin-top: 19px;\n}\n\n.card-title {\n  //height: 30px;\n  //width: 145px;\n  color: @text-primary-color;\n  //font-family: \"Source Sans Pro\";\n  font-size: 24px;\n  font-weight: 600;\n  //line-height: 30px;\n  text-align: center;\n  //margin-bottom: 8px;\n}\n\n.postal-code {\n  height: 40px;\n  width: 150px;\n  border: 1px solid #7D91AC;\n  border-radius: 4px;\n  background-color: @button-primary-color;\n}\n\n.start-application-widget {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin-left: 61px;\n  margin-right: 61px;\n}\n\n.input-postal-code-text {\n  //font-family: \"Source Sans Pro\";\n  text-align: center;\n  height: 40px;\n  width: 150px;\n  border: 1px solid #7D91AC;\n  border-radius: 4px;\n  margin-bottom: 24px;\n}\n\n.start-quote-button {\n  height: 48px;\n  width: 149px;\n  color: @button-primary-color;\n  //font-family: \"Source Sans Pro\";\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  text-align: center;\n  text-shadow: 0 1px 2px 0 rgba(40,51,63,0.16);\n  margin-bottom: 25px;\n  &:disabled {\n    background-color: @button-primary-disabled-color;\n    cursor: auto;\n    &:hover {\n      background-color: @button-primary-disabled-color;\n      color: @button-primary-color;\n    }\n  }\n  &:hover {\n    background-color: @button-primary-hover-color\n  }\n  &:active {\n    background-color: @button-primary-active-color\n  }\n}\n\n.retrieve-quote-button {\n  color: @button-primary-background-color;\n  //font-family: \"Source Sans Pro\";\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  text-align: center;\n  &:hover {\n    background-color: @button-tertiary-hover-color\n  }\n  &:active {\n    background-color: @button-tertiary-active-color\n  }\n  padding: 0;\n}\n\n.retrieve-button {\n  height: 48px;\n  width: 100%;\n  color: @button-primary-color;\n  //font-family: \"Source Sans Pro\";\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  text-align: center;\n  text-shadow: 0 1px 2px 0 rgba(40,51,63,0.16);\n  margin-bottom: 25px;\n  &:disabled {\n    background-color: @button-primary-disabled-color;\n    cursor: auto;\n    &:hover {\n      background-color: @button-primary-disabled-color;\n      color: @button-primary-color;\n    }\n  }\n  &:hover {\n    background-color: @button-primary-hover-color\n  }\n  &:active {\n    background-color: @button-primary-active-color\n  }\n}\n\n.ant-radio-group-solid .yes-no.ant-radio-button-wrapper {\n  &:hover {\n    background-color: @button-primary-hover-color;\n    color: @button-primary-color;\n  }\n  &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n    background-color: @button-primary-background-color;\n    &:hover{\n      background-color: @button-primary-background-color;\n    }\n  }\n}\n\n.secondary-button {\n  &:hover {\n    background-color: @button-primary-hover-color;\n    color: @button-primary-color;\n  }\n  &:active {\n    background-color: @button-primary-active-color;\n    color: @button-primary-color;\n  }\n}\n\n.link-to-step {\n  &:hover {\n    color: @button-primary-background-color;\n  }\n}\n\n.summary-text-group {\n  display: flex;\n  flex-direction: column;\n  margin-right: 135px;\n}\n\n.mouse-hover:hover {\n  cursor: pointer;\n  color: @button-primary-hover-color;\n  background-color: @navigation-hover-background;\n}\n\n.mouse-hover-no-color:hover {\n  cursor: pointer;\n}\n\n.mouse-hover-no-bgColor:hover {\n  cursor: pointer;\n  color: @button-primary-hover-color;\n  background-color: @color-bg;\n  z-index: 3;\n}\n\n.has-interest-in-panel.ant-collapse-item-active .ant-collapse-header {\n  border-bottom: 1px solid @border-color-base;\n  margin-bottom: 1rem;\n}\n\n.summary-buttons {\n  background-color: @button-primary-background-color;\n  color: @button-primary-color;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  &:hover {\n    background-color: @button-primary-active-color;\n    cursor: pointer;\n  }\n}\n\n.success-notification {\n  .ant-alert-message {\n    color: white;\n  }\n  background-color: @gw-color-alert-success;\n  padding-left: 3em!important;\n  margin-bottom: 1em;\n}\n\n.error-notification {\n  .ant-alert-message {\n    color: white;\n  }\n  background-color: @gw-color-alert-error;\n  padding-left: 3em!important;\n  margin-bottom: 1em;\n\n}\n\n.info-notification {\n  .ant-alert-message {\n    color: white;\n  }\n  background-color: @gw-color-alert-info;\n  padding-left: 3em!important;\n  margin-bottom: 1em;\n}\n\n.warning-notification {\n  color: @text-color;\n  background-color: @gw-color-alert-warning;\n  margin-bottom: 1.5em;\n  display: flex;\n  padding: 12px 12px;\n  border-radius: 4px;\n}\n\n.agent-error-notification {\n  color: white;\n  background-color: @gw-color-alert-error;\n  margin-bottom: 1.5em;\n  display: flex;\n  padding: 12px 12px;\n  border-radius: 4px;\n}\n\n.agent-success-notification {\n  color: white;\n  background-color: @gw-color-alert-info;\n  margin-bottom: 1.5em;\n  display: flex;\n  padding: 12px 12px;\n  border-radius: 4px;\n}\n\n.fieldSuccess {\n  color: @gw-color-alert-success;\n  font-style: italic;\n  font-size: 0.9em;\n  position: absolute;\n}\n\n.consumer-consent-title .ant-card-meta {\n  &.ant-card-meta-title {\n    font-size: 24px;\n  }\n  display: flex;\n  align-items: center;\n}\n\n.consumer-consent-title.ant-card-meta-title {\n    font-size: 24px;\n}\n\n.return-home-link {\n  font-size: 18px;\n  color: @link-color;\n  margin-top: 0.5em;\n  &:hover {\n    color: @button-primary-hover-color;\n  }\n  &:active {\n    color: @button-primary-active-color;\n  }\n}\n\n.ant-radio-group-solid .vehicle-type.ant-radio-button-wrapper {\n  &:hover {\n    background-color: white;\n    color: @text-color;\n    cursor: default;\n  }\n  &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n    background-color: @button-primary-background-color;\n    cursor: default;\n    &:hover{\n      background-color: @button-primary-background-color;\n      color: white;\n      cursor: default;\n    }\n  }\n}\n\n.form-support-text {\n  margin-bottom: 32px;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 1.35;\n  display: block;\n  margin-left: 32px;\n}\n\n.property-form-fields {\n  margin-left: 32px;\n}\n\n.property-list-form-header {\n  .ant-collapse-header {\n    font-weight: bold;\n    font-size: 16px;\n  }\n  .ant-collapse .ant-collapse-item .ant-collapse-header {\n    font-weight: bold;\n    font-size: 14px;\n  }\n}\n\n.property-page .ant-collapse-borderless > .ant-collapse-item {\n  border-bottom-width: 0;\n}\n\n.alarm-security {\n  border-bottom: 1px solid grey;\n}\n\n.ant-collapse-content.ant-collapse-content-active {\n  overflow: visible\n}\n\n.dwelling-coverages {\n  border-bottom: 0px;\n}\n\n.additional-coverages-modal.ant-modal {\n  width: min-content;\n}\n\n.personal-auto-totals-premium {\n  float: right;\n  margin-right: 30px;\n  &.mobile {\n    margin-right: -5px;\n  }\n}\n\n#estimated-quote-text{\n  font-size: 14px;\n}\n\n.bold-text{\n  font-weight: bold;\n}\n\n.totals-premium-holder{\n  padding: 16px;\n  .ant-row{\n    padding-top: 5px;\n    padding-bottom: 5px;\n  }\n  .quote-totals-premium{\n    font-weight: bold;\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n#estimated-prem-title{\n  text-align: center;\n}\n\n.renovations-description{\n  margin-bottom: 15px;\n}\n","@import (inline) 'fonts.css';\n\nhtml {\n  background-color: #fff;\n  font-size: 16px;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  min-width: 300px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  text-rendering: optimizeLegibility;\n  font-family: 'Source Sans Pro', sans-serif;\n}\n\narticle,\naside,\nfigure,\nfooter,\nheader,\nhgroup,\nsection {\n  display: block;\n}\n\nbody,\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: \"Source Sans Pro\", BlinkMacSystemFont, -apple-system, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n}\n\ncode,\npre {\n  -moz-osx-font-smoothing: auto;\n  -webkit-font-smoothing: auto;\n  font-family: monospace;\n}\n\nbody {\n  color: @reset-color;\n  font-family: 'Source Sans Pro';\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\na {\n  cursor: pointer;\n  text-decoration: none;\n  -webkit-transition: none 86ms ease-out;\n  transition: none 86ms ease-out;\n}\n\na:hover {\n  color: #363636;\n}\n\ncode {\n  background-color: whitesmoke;\n  color: #ff3860;\n  font-size: 0.8em;\n  font-weight: normal;\n  padding: 0.25em 0.5em 0.25em;\n}\n\nhr {\n  background-color: #dbdbdb;\n  border: none;\n  display: block;\n  height: 1px;\n  margin: 0.7rem 0;\n}\n\nimg {\n  height: auto;\n  max-width: 100%;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  vertical-align: baseline;\n}\n\nsmall {\n  font-size: 0.875em;\n}\n\nspan {\n  font-style: inherit;\n  font-weight: inherit;\n}\n\nstrong {\n  color: #363636;\n  font-weight: 700;\n}\n\npre {\n  background-color: whitesmoke;\n  color: @reset-color;\n  font-size: 0.8em;\n  white-space: pre;\n  word-wrap: normal;\n}\n\npre code {\n  -webkit-overflow-scrolling: touch;\n  background: none;\n  color: inherit;\n  display: block;\n  font-size: 1em;\n  overflow-x: auto;\n  padding: 1.25rem 1.5rem;\n}\n\ntable, .table {\n  width: 100%;\n}\n\ntable td,\ntable th,\n.table .td {\n  text-align: left;\n  vertical-align: top;\n  padding: 0.5em 0.75em;\n}\n\ntable th, .thead .td {\n  color: #363636;\n}\n\n",".btn-group {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 28px;\n}\n\n.cancel-button {\n  color: @primary-color;\n  background-color: #ffffff;\n  border: none;\n}\n\n.cancel-button:hover {\n  cursor: pointer;\n  background-color: #f2f2f2;\n  height: 32px;\n}\n\n\n",".fieldError {\n  color: salmon;\n  font-style: italic;\n  font-size: 0.9em;\n  position: absolute;\n}\n\n.form-disabling-overlay {\n  position: absolute;\n  z-index: 999;\n  background-color: white;\n  opacity: 0.5;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n\n","\n.coverage-table{\n  .coverage-table-input{\n    width: 105px;\n  }\n  &.mobile{\n    .coverage-detail-row{\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      align-content: center;\n      padding: 8px 16px;\n    }\n    .coverage-detail-row:nth-child(odd){\n      background: #f8f9fa;\n    }\n    .coverage-detail-row:only-child{\n      background: #ffffff;\n    }\n    .ant-row{\n      display: flex;\n      align-items: center;\n      margin-bottom: 10px;\n    }\n    .label{\n      display: flex;\n      justify-content: flex-start;\n    }\n    .field{\n      display: flex;\n      justify-content: flex-end;\n      font-weight: bold;\n      text-align: right;\n    }\n  }\n  &.desktop{\n    .label{\n      font-weight: bold;\n    }\n  }\n}\n\n.medical-payments-written-premium{\n  font-size: 12px;\n}\n\n.deduction-value-panel{\n  .field-label-col {\n    margin-right: 10px;\n  }\n}\n\n",".coverage-table-summary {\n  padding: 16px;\n\n  > #coverage-summary-table-header {\n    font-weight: bold;\n  }\n  .coverage-detail-row{\n    padding: 8px 16px;\n    >.ant-row{\n      margin-bottom: 10px;\n    }\n  }\n  .description-col {\n    word-break: break-word;\n  }\n\n  .limit-col {\n    text-align: end;\n    word-break: break-word;\n  }\n\n  .premium-col {\n    text-align: end;\n  }\n}\n\n.coverage-table-summary.mobile {\n  .coverage-detail-row:nth-child(odd) {\n    background: #f8f9fa;\n  }\n  .description-col {\n    text-align: end;\n    font-weight: bold;\n  }\n}\n\n",".checkbox-input{\n  display: flex;\n  > .field-label-col{\n    margin-left: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
